module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_5010.360bb058.png";